import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import requireAuth from "../context/requireAuth";
import axios from "axios";

function CreateNew() {

    const [isAdmin, setIsAdmin] = useState(false)

    const org_id = localStorage.getItem("organization");

    useEffect(() => {
        axios.get(`${org_id}/checkuser`, {withCredentials: true})
            .then(res => {
            if (res.data.role === "admin") {
                setIsAdmin(true);
            }
            })
            .catch(err => console.log(err));
    }, [])
    
    return(
        <div className="bodyContent">
            <div className="centered">
               <h1 className="title"> Create New </h1>
                <div className="homeGrid">
                    <Link to="/newPlant">
                    <div className="purpleBox">
                        <p className="linkText">New Plant</p>
                    </div>
                    </Link>
                    <Link to="/newPlot">
                    <div className="purpleBox">
                        <p className="linkText">New Plot</p>
                    </div>
                    </Link>
                    <Link to="/newRoom">
                        <div className="purpleBox">
                            <p className="linkText">New Room</p>
                        </div>
                    </Link>
                    <Link to="/newProduct">
                    <div className="purpleBox">
                        <p className="linkText">New Product</p>
                    </div>
                    </Link>
                    {isAdmin && (
                    <Link to="/newAccount">
                    <div className="purpleBox">
                        <p className="linkText">New Account</p>
                    </div>
                    </Link>
                    )}
                </div>
            </div>
            </div>
    )
}

export default requireAuth(CreateNew);